/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Int32ApiResponse } from '../../models/int-32-api-response';

export interface CreateDepositContractAsync$Plain$Params {
  id: number;
      body?: {
'ContractId'?: number;
'Amount'?: number;
'TransferedDate'?: string;
'File'?: Blob;
}
}

export function createDepositContractAsync$Plain(http: HttpClient, rootUrl: string, params: CreateDepositContractAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createDepositContractAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Int32ApiResponse>;
    })
  );
}

createDepositContractAsync$Plain.PATH = '/api/contract/{id}/deposit';
